import styled from 'styled-components'
import { getDashColor } from '../../styles'

export const BannerLink = styled.a`
  display: block;
  width: 100%;
  margin: 32px 0;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid ${getDashColor('GRAY_SCALE_08', 'BEIGE')};
  box-shadow: 0px 12px 32px rgba(0, 0, 0, 0.08);
  transition: transform 180ms ease, box-shadow 180ms ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0px 16px 36px rgba(0, 0, 0, 0.12);
  }

  &:focus-visible {
    outline: 2px solid ${getDashColor('PRIMARY_RED_01', 'SECONDARY_COLOR')};
    outline-offset: 4px;
  }
`;

export const BannerImage = styled.img`
  display: block;
  width: 100%;
  height: auto;
`;
